import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import ShopCreateTokenPage from "../shop/pages/ShopCreateTokenPage.vue";

export const ShopRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "shop"
) => [
  {
    name: "ShopCreateTokenPage",
    path: `${prefix}/create-token`,
    component: ShopCreateTokenPage,
    meta: { title: "Shop Create Token" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.CREATE_SHOP_NOTI_TOKEN
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
